import { useRef } from "react";
import { motion, useAnimationFrame, useMotionValue, useScroll, useSpring, useTransform, useVelocity } from "framer-motion";

const WORDS = ["65+ Years", "Arcade Games", "Claw & Prize", "Jukeboxes", "Pool Tables", "ATMs", "Installation", "Service & Repair", "Revenue Share", "McMinnville, TN"];
const wrap = (min, max, v) => {
  const r = max - min;
  return ((((v - min) % r) + r) % r) + min;
};

const Row = ({ outline }) => (
  <div className="flex shrink-0 items-center">
    {WORDS.map((w, i) => (
      <span key={w} className="flex items-center">
        <span className={`px-8 font-display font-extrabold uppercase tracking-[-0.03em] ${outline ? "text-3xl text-outline sm:text-5xl" : `text-5xl sm:text-7xl ${i % 2 ? "text-outline" : "text-white"}`}`}>{w}</span>
        <span className={`h-3 w-3 rotate-45 ${i % 3 === 2 ? "bg-signal" : "bg-volt"}`} />
      </span>
    ))}
  </div>
);

const Track = ({ base, outline }) => {
  const x = useMotionValue(0);
  const { scrollY } = useScroll();
  const vel = useSpring(useVelocity(scrollY), { damping: 50, stiffness: 400 });
  const factor = useTransform(vel, [-2000, 0, 2000], [-4, 0, 4], { clamp: false });
  const dir = useRef(1);
  useAnimationFrame((_, delta) => {
    const f = factor.get();
    if (f < -0.05) dir.current = -1;
    else if (f > 0.05) dir.current = 1;
    const move = base * dir.current * (1 + Math.abs(f)) * (delta / 1000);
    x.set(wrap(-50, 0, x.get() + move));
  });
  const tx = useTransform(x, (v) => `${v}%`);
  return (
    <motion.div style={{ x: tx }} className="flex w-max">
      <Row outline={outline} />
      <Row outline={outline} />
    </motion.div>
  );
};

export const Marquee = () => (
  <section className="relative overflow-hidden border-y border-white/5 bg-ink-900 py-10" aria-hidden data-testid="editorial-marquee">
    <Track base={-1.2} />
    <div className="mt-6 opacity-60">
      <Track base={0.9} outline />
    </div>
  </section>
);
